import { render, staticRenderFns } from "./YearComponent.vue?vue&type=template&id=a8e386a0&scoped=true&"
import script from "./YearComponent.vue?vue&type=script&lang=js&"
export * from "./YearComponent.vue?vue&type=script&lang=js&"
import style0 from "./YearComponent.vue?vue&type=style&index=0&id=a8e386a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e386a0",
  null
  
)

export default component.exports